import React from "react";

// components

export default function CardFAQ() {
  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0">
        <div className="rounded-t bg-white mb-0 px-6 py-6">
          <div className="text-center flex justify-between">
            <h6 className="text-gray-800 text-xl font-bold">FAQ</h6>
          </div>
        </div>
        <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
          <form>
            <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">              
            </h6>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-12/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-gray-700 text-xs font-bold mb-2" htmlFor="grid-password">
                    Refund?
                  </label>
                  Only unused loans can be refunded. You can send an e-mail to get information about this. Proof of your expenditures is shown in the Process History section and your records are kept. We can prove loans if you apply via Paypal.<br/><br/>
                  <label className="block uppercase text-gray-700 text-xs font-bold mb-2" htmlFor="grid-password">
                  Internet Connection Required?
                  </label>
                  Yes, you must have an internet connection in order to use the MbLink Cluster application. Otherwise it will not work.<br/><br/>
                  <label className="block uppercase text-gray-700 text-xs font-bold mb-2" htmlFor="grid-password">
                  Eprom Editing
                  </label>
                  As you know, editing data in eprom is a risky process. A data you write incorrectly can prevent it from being reopened for the cluster. This risk is entirely yours. Mblink cluster cannot be held responsible for this issue. We would like to remind you that you accept this situation during the registration process.<br/><br/>
                  <label className="block uppercase text-gray-700 text-xs font-bold mb-2" htmlFor="grid-password">
                  Confiscation
                  </label>
                  If we detect any cracking or hacking on our site or program, we may close your account indefinitely and without warning, and confiscate the credits it has received. These credits will not be refunded.<br/><br/>
                  <label className="block uppercase text-gray-700 text-xs font-bold mb-2" htmlFor="grid-password">
                  Password of Setup
                  </label>
                  Installation password is ready for paying users.
                  <br/><br/>
                  <label className="block uppercase text-gray-700 text-xs font-bold mb-2" htmlFor="grid-password">
                  About Credits
                  </label>
                  The credits received are stored indefinitely. Discounts can be made for high loan purchases.
                  <br/><br/>
                  <label className="block uppercase text-gray-700 text-xs font-bold mb-2" htmlFor="grid-password">
                  Unlimited Usage?
                  </label>
                  Credits spent are only valid for 1 cluster. You can use it on the same cluster without limits. 
                  For example, when you take an Eprom read/write credit and make a process then you can do unlimited eprom read/write for that cluster.
                </div>
              </div>
            </div>

            <hr className="mt-6 border-b-1 border-gray-400" />

          </form>
        </div>
      </div>
    </>
  );
}
